import { Cancel } from "@mui/icons-material"
import CheckIcon from "@mui/icons-material/Check"
import RestartAltIcon from "@mui/icons-material/RestartAlt"
import { Box, IconButton, useTheme } from "@mui/material"
import React, { useRef } from "react"
import { default as SignatureCanvas, default as SignatureCanvasRef } from "react-signature-canvas"
import { useUseableHeight, useWindowDimensions } from "../utils/styling"

const rotateCanvas = (canvas: HTMLCanvasElement): HTMLCanvasElement => {
    const rotatedCanvas = document.createElement("canvas")
    const ctx = rotatedCanvas.getContext("2d")

    rotatedCanvas.width = canvas.height
    rotatedCanvas.height = canvas.width

    ctx?.translate(rotatedCanvas.width / 2, rotatedCanvas.height / 2)
    ctx?.rotate((90 * Math.PI) / 180)
    ctx?.drawImage(canvas, -canvas.width / 2, -canvas.height / 2)

    return rotatedCanvas
}

const maxHeight = 1100

interface ISignatureProps {
    setImg?: (signature: string) => void
    handleClose?: () => void
}

const Signature = (props: ISignatureProps) => {
    const signatureCanvasRef = useRef<SignatureCanvasRef>(null)
    const listStyles = {
        "@media (max-height : 600px)": {
            height: "60vh",
        },
    }
    const useableHeight = useUseableHeight()
    const { width } = useWindowDimensions()
    const theme = useTheme()
    const signatureCanvasWidth = Math.min(width, 700)
    const signatureCanvasHeight = Math.min(useableHeight, maxHeight)

    const handleSaveSignature = () => {
        if (signatureCanvasRef.current) {
            const signatureData = signatureCanvasRef.current.getCanvas()
            const rotatedSignature = rotateCanvas(signatureData)

            if (signatureCanvasRef.current.isEmpty()) {
                console.log("Signature is empty")
            } else {
                props?.setImg && props?.setImg(rotatedSignature.toDataURL())
            }
            props?.handleClose && props?.handleClose()
        } else {
            console.log("Signature is empty")
        }
    }

    return (
        <Box
            sx={[listStyles]}
            width={"100%"}
            height={useableHeight}
            maxWidth={700}
            maxHeight={maxHeight}
            display="flex"
            flexDirection="row-reverse"
            bgcolor={"white"}
            minHeight={"30vh"}
            position={"absolute"}
            top={useableHeight > maxHeight ? (useableHeight - maxHeight) / 2 : 0}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 5,
                    width: "20%",
                    marginY: 6,
                }}
            >
                <Box>
                    <Box sx={{ paddingBottom: 2 }}>
                        <IconButton
                            onClick={() => {
                                if (signatureCanvasRef.current) {
                                    signatureCanvasRef.current.clear()
                                }
                            }}
                            sx={{
                                color: "white",
                            }}
                            style={{ backgroundColor: theme.palette.secondary.main }}
                        >
                            <RestartAltIcon sx={{ rotate: "-90deg" }} />
                        </IconButton>
                    </Box>
                    <IconButton
                        sx={{
                            color: "white",
                            backgroundColor: "secondary.main",
                        }}
                        // eslint-disable-next-line @typescript-eslint/no-empty-function
                        onClick={props?.handleClose || (() => {})} // Fallback to an empty function
                    >
                        <Cancel />
                    </IconButton>
                </Box>
                <IconButton
                    onClick={() => {
                        handleSaveSignature()
                    }}
                    sx={{
                        color: "white",
                    }}
                    style={{ backgroundColor: theme.palette.primary.main }}
                >
                    <CheckIcon sx={{ rotate: "-90deg" }} />
                </IconButton>
            </Box>
            <Box width={"80%"} height={"100%"}>
                <SignatureCanvas
                    ref={signatureCanvasRef}
                    penColor="black"
                    canvasProps={{
                        width: signatureCanvasWidth,
                        height: signatureCanvasHeight,
                        className: "sigCanvas",
                    }}
                />
            </Box>
        </Box>
    )
}

export default Signature
